import { types } from 'mobx-state-tree'
import { DictionaryModel } from '../common'
import { WorkPricesCoefficientsModel } from './WorkPricesCoefficientsModel'
import { PriceRegionMeasurementUnitModel } from './PriceRegionMeasurementUnitModel'

export const WorkPriceModel = types.model('WorkPriceModel', {
  id: types.number,
  currencyId: types.number,
  workId: types.maybeNull(types.number),
  measurementUnitId: types.number,
  headRegionMeasurementUnitId: types.number,
  isDeletable: types.boolean,
  lastModified: types.string,
  price: types.number,
  work: DictionaryModel,
  coefficients: types.array(WorkPricesCoefficientsModel),
  priceRegionMeasurementUnits: types.array(PriceRegionMeasurementUnitModel),
})
